export function setCookie(cname, cvalue, exdays) {
    let expires = "";
    if (exdays !== undefined && exdays !== null) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        expires = "expires="+ d.toUTCString() + ";";
    }
    const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
    const secureFlag = isHttps ? 'Secure;' : '';
    document.cookie = cname + "=" + cvalue + ";" + expires + "path=/;" + secureFlag + "SameSite=Lax";
}

export function getCookie(cname) {
    if (typeof document === 'undefined') return "";
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

export function dateFormat(date) {
  if (!date) return '';
  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  return year + '-' + month + '-' + day;
}

export function deleteCookie(name) {
    if (typeof document === 'undefined') return;
    const expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    const paths = ["/", ""];
    const domains = [
        "",
        typeof window !== 'undefined' ? window.location.hostname : "",
        typeof window !== 'undefined' && window.location.hostname.includes('.') ? `.${window.location.hostname}` : ""
    ];
    const samesites = ["; SameSite=Lax", "; SameSite=Strict", "; SameSite=None", ""];
    const secures = ["; Secure", ""];

    paths.forEach(path => {
        domains.forEach(domain => {
            samesites.forEach(samesite => {
                secures.forEach(secure => {
                    const pathStr = path ? `; path=${path}` : "";
                    const domainStr = domain ? `; domain=${domain}` : "";
                    document.cookie = `${name}=; ${expires}${pathStr}${domainStr}${samesite}${secure}`;
                    document.cookie = `${name}=; Max-Age=-99999999${pathStr}${domainStr}${samesite}${secure}`;
                });
            });
        });
    });
}

export function clearAllCookies() {
    if (typeof document === 'undefined') return;
    const cookies = document.cookie.split(';');
    const cookieNames = new Set([
        'token',
        'refreshToken',
        'tokenTimeStamp',
        'data',
        'owner_user_id',
        'cid',
        'uid',
        'user_uid',
        'authToken',
        'authTokenTimestamp',
        'branch_id',
        'impersonate'
    ]);

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if (name) {
            cookieNames.add(name);
        }
    }

    cookieNames.forEach(name => {
        deleteCookie(name);
    });
}

export function setLocalStorage(storageid, data) {
  window.localStorage.setItem(storageid, JSON.stringify(data))
}

export function getLocalStorage(storageid) {
  var data = window.localStorage.getItem(storageid)
  return data ? JSON.parse(data) : {}
}


